// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"e6d5fbea","238":"4b79ef7b","239":"dfdb0d71","455":"a53eb272","857":"f0fcf8e3","977":"b5623f9a"}[chunkId] + ".chunk.js";
};